import React from "react";
import styles from "./box.module.scss";
import MiViewer from '../../../assets/New folder/vvv.jpg'
import MOB_2 from '../../../assets/New folder/mob.jpg'
// import HAPPY_CUSTOMER from '../../../assets/HAPPY_CUSTOMER.jpg'
// import millensys_support_client from '../../../assets/PDF/millensys_support_client.zip'
import { Link } from "react-router-dom";
import { MdDownloadForOffline } from "react-icons/md";
import { MdOutlineProductionQuantityLimits } from "react-icons/md";


const Box = () => {
  return (
    <section className={styles.box_container}>
      <div className={styles.___container}>
        {/* Box 1  */}
        <div className={styles.__box}>
          <div className={styles.__box_main}>
            <div className={styles.__box_leftside}>
              <div className={styles.__box_image}>
                <img src={MiViewer} alt='GET SUPPORT' loading="lazy"/>
              </div>
            </div>
            <div className={styles.__box_rightside}>
              <Link to='/products/32' className={styles._headding}>
              <MdDownloadForOffline/> | MILLENSYS DICOM Viewer (Free)
              </Link>
              <strong className={styles.__strong}>
              Free DICOM Viewer for daily usage
              </strong>
              <p className={styles.__content}>
                MILLENSYS Viewer "MiViewer" is a very easy to use general dicom viewer software to view multi-modality images and cine-loops using
                the same software. MiViewer can load images from dicom CD/DVD and from any other media e.g. HDD.
                For more powerful viewing, visit Vision Tools MultiView workstation site
              </p>
              <button className={styles["product___btn"]}>
                <Link to='/order' ><MdOutlineProductionQuantityLimits/> | Order</Link>
              </button>
            </div>
          </div>
        </div>

        {/* Box 2  */}
        <div className={styles.__box}>
          <div className={styles.__box_main}>
            <div className={styles.__box_rightside}>
              <Link to='/products/15' className={styles._headding}>
              <MdDownloadForOffline/> | MILLENSYS Health Wallet (Free)
              </Link>
              <strong className={styles.__strong}>
              Telemedicine and Patient Engagement Mobile Application
              </strong>
              <p className={styles.__content}>
                MILLENSYS Health Wallet is a smart tool to keep patients engaged with their health care service providers, in which, the patient can schedule new visits or exams ,
                track his/her appointments and keep track of his medical record at the facility.
                The patient can view his reports and images from this application as well as more clinical information on his case
              </p>
              <button className={styles["product___btn"]}>
              <Link to='/order' ><MdOutlineProductionQuantityLimits/> | Order</Link>
              </button>
              <div className={styles["product___btn__con"]} >
                <button className={styles["product___btn__1"]}>
                  <Link to='https://play.google.com/store/apps/details?id=com.millensys.healthwallet' ></Link>
                </button>
                <button className={styles["product___btn__2"]}>
                  <Link to='https://apps.apple.com/us/app/millensys-health-wallet/id1582782529' ></Link>
                </button>
              </div>
            </div>

            <div className={styles.__box_leftside}>
              <div className={styles.__box_image}>
                <img src={MOB_2} alt='MILLENSYS-GET_SUPPORT' loading="lazy"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Box;
